// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"332":"36eb6223","399":"b18f70f0","451":"36eb6223","511":"e8cb667a"}[chunkId] + ".chunk.css";
};